// extracted by mini-css-extract-plugin
module.exports = {"card":"Facts2_card__1MT71","footer":"Facts2_footer__32gwv","header":"Facts2_header__2EdDy","wrapper":"Facts2_wrapper__3Eela"};